<template>
  <table>
    <tr v-if="currentTimestamp">
      <td>
        <strong>Current Time: &nbsp</strong>
      </td>
      <td>
        <span class='fixed-width-time'>{{ currentFormatted }}</span>
      </td>
      <td>
        {{ timezone }}
      </td>
    </tr>
    <tr v-if="startTimestamp">
      <td>
        <strong>Session start: &nbsp</strong>
      </td>
      <td>
        <span class='fixed-width-time'>{{ startFormatted }}</span>
      </td>
      <td>
        {{ timezone }}
      </td>
    </tr>
    <tr v-if="endTimestamp">
      <td>
        <strong>Session end: &nbsp</strong>
      </td>
      <td>
        <span class='fixed-width-time'>{{ endFormatted }}</span>
      </td>
      <td>
        {{ timezone }}
      </td>
    </tr>
  </table>
</template>

<script>
  import Moment from 'moment';

  import 'rti.css';

  export default {
    name: 'timePanel',
    props: ['utcNow', 'currentTimestamp', 'startTimestamp', 'endTimestamp'],
    data: function() {
      return {
        timezone: 'UTC'
      };
    },
    computed: {
      currentFormatted: function() {
        return this.formatTimestamp(this.currentTimestamp);
      },
      startFormatted: function() {
        return this.formatTimestamp(this.startTimestamp);
      },
      endFormatted: function() {
        return this.formatTimestamp(this.endTimestamp);
      }
    },
    methods: {
      formatTimestamp: function(timestamp) {
        return Moment.unix(timestamp).utc().format('YYYY-MM-DD HH:mm:ss');
      }
    }
  };
</script>